<span class="document-type" [ngClass]="[chat?.super_type?.toLowerCase() || '', chat?.document_type?.toLowerCase() || '']">
  {{chat?.super_type | human}}
</span>